/* eslint-disable import/prefer-default-export */
export enum SubscriptionType {
  INIT_SUBSCRIPTION = 'subscriptionState/INIT_SUBSCRIPTION',
  UPDATE_EXPIRATION = 'subscriptionState/UPDATE_EXPIRATION'
}
